import { render, staticRenderFns } from "./ListaImovel.vue?vue&type=template&id=51741050&"
import script from "./ListaImovel.vue?vue&type=script&lang=js&"
export * from "./ListaImovel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports